export default {"src":"/_next/static/media/Counsellor.e8024e75.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};